import { useEffect, useMemo } from 'react';

import { useApi } from '../useApi/useApi.hook';

import type { UseQueryParams, UseQueryResult } from './useQuery.types';

export function useQuery<DataResultType>({
  url,
  headers,
  baseUrl,
  params,
  skip,
  shouldTrackException,
}: UseQueryParams): UseQueryResult<DataResultType> {
  const urlWithParams = useMemo(() => {
    if (!params) {
      return url;
    }

    const searchParams = new URLSearchParams(params);

    return `${url}?${searchParams.toString()}`;
  }, [params, url]);

  const { result, error, isLoading, status, executeRequest } =
    useApi<DataResultType>(
      urlWithParams,
      {
        headers,
      },
      baseUrl,
      shouldTrackException
    );

  const isFetching = !result && !error && isLoading;

  useEffect(() => {
    if (!skip) {
      void executeRequest();
    }
  }, [skip, executeRequest]);

  return {
    result: result ?? null,
    error: error ?? null,
    isLoading,
    isFetching,
    isError: Boolean(error),
    status,
    execute: executeRequest,
  };
}
